import { SectionLink } from './SectionLinks'
import React from 'react'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
import { ButtonBase, Collapse } from '@material-ui/core'
import messages from '@utils/messages'
import CaretDownIcon from '@src/icons/CaretDownIcon'
import { DocumentLink } from '@src/types/graphql-types'

interface ClassesInterface {
  expandTrigger?: string
  caretIcon?: string
  caretIconExpanded: string
}

interface CollapsibleLinksProps {
  links: DocumentLink[]
  classes: ClassesInterface
  country: string
  language: string
  setExpanded: (expanded: boolean) => void
  hasExpanded: boolean
  expanded: boolean
  limit: number
  productNumber?: string
  isBlueProduct?: boolean
  section: string
}

export const CollapsibleLinks: React.FC<CollapsibleLinksProps> = ({
  links,
  classes,
  country,
  language,
  setExpanded,
  hasExpanded,
  expanded,
  limit,
  productNumber,
  isBlueProduct,
  section,
}) => {
  const showMessage = expanded ? messages.SHOW_LESS : messages.SHOW_MORE

  return hasExpanded ? (
    <>
      <Collapse in={expanded} timeout="auto">
        {links.slice(limit, links.length).map((link, index) => (
          <SectionLink
            key={link.label}
            index={index}
            country={country}
            language={language}
            link={link}
            classes={classes}
            productNumber={productNumber}
            isBlueProduct={isBlueProduct}
            section={section}
          />
        ))}
      </Collapse>
      <ButtonBase
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
        aria-label="Show more"
        className={classes.expandTrigger}
        id="properties-expansion-toggle"
      >
        <div>
          <FormattedMessage {...showMessage} />
        </div>
        <CaretDownIcon
          className={clsx(classes.caretIcon, {
            [classes.caretIconExpanded]: expanded,
          })}
        />
      </ButtonBase>
    </>
  ) : null
}
